export function viewFileMacro() {
	// noop. All comes from WRM.
}

export function viewFileMacroWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-editor-resources',
	];
}
